import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-16 lg:py-24 bg-neutral-50" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7"
}
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7"
}
const _hoisted_6 = { class: "relative overflow-hidden h-52" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "w-full h-full bg-neutral-100 flex items-center justify-center"
}
const _hoisted_9 = { class: "absolute top-3 left-3 bg-primary-500 text-white text-xs font-semibold px-3 py-1 rounded-full" }
const _hoisted_10 = { class: "p-5" }
const _hoisted_11 = { class: "flex items-center gap-3 text-xs text-neutral-400 mb-3" }
const _hoisted_12 = { class: "flex items-center gap-1.5" }
const _hoisted_13 = { class: "flex items-center gap-1.5" }
const _hoisted_14 = { class: "text-base font-bold text-neutral-800 mb-2 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors" }
const _hoisted_15 = { class: "text-sm text-neutral-500 mb-4 leading-relaxed line-clamp-2" }
const _hoisted_16 = { class: "border-t border-neutral-100 pt-4" }
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = { class: "w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0" }
const _hoisted_20 = { class: "text-xs font-bold text-primary-600" }
const _hoisted_21 = { class: "text-xs font-medium text-neutral-600" }
const _hoisted_22 = {
  key: 2,
  class: "text-center py-16 text-neutral-400 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", null, [
          _createElementVNode("p", { class: "text-primary-500 text-sm font-semibold uppercase tracking-widest mb-2" }, "Latest News"),
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-neutral-800" }, " Blog & Articles ")
        ], -1)),
        _createVNode(_component_router_link, {
          to: "/blogs",
          class: "inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors group"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" View All Posts ", -1),
            _createElementVNode("svg", {
              class: "w-4 h-4 group-hover:translate-x-1 transition-transform",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M17 8l4 4m0 0l-4 4m4-4H3"
              })
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "bg-white rounded-2xl border border-neutral-100 shadow-sm overflow-hidden animate-pulse"
              }, [...(_cache[2] || (_cache[2] = [
                _createStaticVNode("<div class=\"h-52 bg-neutral-200\" data-v-0f98ef48></div><div class=\"p-5 space-y-3\" data-v-0f98ef48><div class=\"h-3 bg-neutral-100 rounded w-1/3\" data-v-0f98ef48></div><div class=\"h-4 bg-neutral-200 rounded w-full\" data-v-0f98ef48></div><div class=\"h-3 bg-neutral-100 rounded w-5/6\" data-v-0f98ef48></div><div class=\"h-3 bg-neutral-100 rounded w-2/3\" data-v-0f98ef48></div></div>", 2)
              ]))])
            }), 64))
          ]))
        : (_ctx.blogPosts.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogPosts, (post) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: post.id,
                  class: "group bg-white rounded-2xl border border-neutral-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    (post.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: post.image,
                          alt: post.title,
                          class: "w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("svg", {
                            class: "w-12 h-12 text-neutral-300",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            })
                          ], -1)
                        ]))])),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" }, null, -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(post.category), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _cache[5] || (_cache[5] = _createElementVNode("svg", {
                          class: "w-3.5 h-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(post.date), 1)
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "w-1 h-1 rounded-full bg-neutral-300" }, null, -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[6] || (_cache[6] = _createElementVNode("svg", {
                          class: "w-3.5 h-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(post.readTime) + " min read ", 1)
                      ])
                    ]),
                    _createElementVNode("h3", _hoisted_14, _toDisplayString(post.title), 1),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(post.excerpt), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(post.authorInitials), 1)
                          ]),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(post.author), 1)
                        ]),
                        _createVNode(_component_router_link, {
                          to: `/blog/${post.id}`,
                          class: "inline-flex items-center gap-1 text-xs font-semibold text-primary-500 hover:text-primary-600 transition-colors group/link"
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" Read More ", -1),
                            _createElementVNode("svg", {
                              class: "w-3.5 h-3.5 group-hover/link:translate-x-0.5 transition-transform",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M9 5l7 7-7 7"
                              })
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, " No blog posts available at the moment. "))
    ])
  ]))
}